import React from 'react';
import { LoadHeader } from './load/LoadHeader';
import PDFUploader from '../../components/PDFUploader';
import { useSidebar } from '../../contexts/SidebarContext';

export const Load = () => {
  const { isExpanded } = useSidebar();
  const leftMargin = isExpanded ? 'ml-64' : 'ml-16';

  return (
    <div className={`${leftMargin} min-h-screen bg-gray-50 transition-all duration-300`}>
      <div className="p-8">
        <LoadHeader />
        <div className="mt-8">
          <div className="bg-white p-4 rounded-md shadow-sm">
            <div className="pt-4">
              <PDFUploader />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Load;